import React from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import {anchorKeys} from "../../models/anchors/AnchorProperty";

interface AnchorPropertyFormProps {
  updateProperty: (index: number,key: any, value: any, arrayIndex:any, changeKey: boolean ) => void;
  deleteProperty: (index: number, arrayIndex: number | undefined) => void;
  property: any;
  index: number;
  arrayIndex?: number | undefined;
}

const AnchorPropertyEditor = (props: AnchorPropertyFormProps) => {
  const propertyKeys = Object.keys(props.property)
  let propertyKey = propertyKeys[0]
  let propertyValue = props.property[propertyKey];

  if(typeof propertyValue === 'object'){
    if(Array.isArray(propertyValue)){
      //propertyValue = Object.fromEntries(propertyValue);
    } else {
      propertyValue = Object.fromEntries(propertyValue);
    }
  }

  propertyValue =  Object.keys(propertyValue).length === 0 ? '' : propertyValue
  propertyKey = propertyKey === 'properties' ? '' : propertyKey;
  const sendAnchorPropertyUpdate = (key: any, value: any, changeKey: boolean) => {
    props.updateProperty(
      props.index,
      key,
      value,
      props.arrayIndex,
      changeKey
    );
  };
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={5}>
        <FormControl  required sx={{ width: "100%" }}>
        <Select
                disabled={propertyKey != "NewItem" && propertyKey != "" && propertyKey != null}
                style={{minWidth:"102px"}}
                labelId="simple-select-label-priority"
                id="demo-simple-select"
                value={propertyKey}
                label="Key"
                onChange={(event: SelectChangeEvent) => {
                  sendAnchorPropertyUpdate(
                    event.target.value,
                    propertyValue,
                    true
                  );
                }
              }
              >
                {anchorKeys.map((anchorKey:string)=> {
                  return ( 
                  <MenuItem key = {anchorKey} value={anchorKey}>
                    {anchorKey}
                  </MenuItem> )
                  })}
              </Select>

        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl required sx={{ width: "100%" }}>
        <TextField
            name="value"
            label="Value"
            type="text"
            value={propertyValue}
            onChange={(event: React.ChangeEvent<any>) => {
              sendAnchorPropertyUpdate(propertyKey, event.target.value, false);
            }}
          ></TextField>
        </FormControl>
      </Grid>
      <Grid item xs={1}>
        <IconButton
          color="primary"
          onClick={() => {
            props.deleteProperty(props.index, props.arrayIndex);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default AnchorPropertyEditor;
